import {inject, Injectable, signal} from '@angular/core';
import {articleMarketplacePaths, defaultArticleMarketplaces} from "../configs/marketplace-config";
import {
  ArticleMarketplaces,
  RemoveArticleMarketplaceItemParams
} from "../types/marketplace.types";
import {RecordsDataRequestQueryParams} from "../../../../core/types/records-table.types";
import {ArticleMarketplaceService} from "../services/article-marketplace.service";

@Injectable({
  providedIn: 'root'
})
export class ArticleMarketplaceStateService {
  private articleMarketplaceService: ArticleMarketplaceService = inject(ArticleMarketplaceService);
  private _articleMarketplacesState = signal<ArticleMarketplaces>(defaultArticleMarketplaces);
  public articleMarketplacesState = this._articleMarketplacesState.asReadonly();

  public async setArticleMarketplacesState(queryParams: RecordsDataRequestQueryParams): Promise<void> {
    const promises = articleMarketplacePaths.map(({ path }) =>
      this.articleMarketplaceService.getMarketplaceData(path, queryParams).catch(() => [])
    );

    const results = await Promise.all(promises);
    const marketplacesData: ArticleMarketplaces = {
      wildberries: results.at(0)?.filter(i => Number(i.productCardId) === Number(queryParams['productCardId'])) || [],
      ozon: results.at(1)?.filter(i => Number(i.productCardId) === Number(queryParams['productCardId'])) || []
    };

    this._articleMarketplacesState.set(marketplacesData);
  }

  public removeArticleMarketplaceItem(removeArticleMarketplaceItemParams: RemoveArticleMarketplaceItemParams): void {
    const { marketplace, id } = removeArticleMarketplaceItemParams;

    this._articleMarketplacesState.update(currentState => {
      const marketplaceData = currentState[marketplace];
      if (!marketplaceData) { return currentState; }

      const filteredData = marketplaceData.filter(item =>
        item.id !== id &&
        item.nmId !== id
      );

      return {
        ...currentState,
        [marketplace]: filteredData
      };
    });
  }

  public clearArticleMarketplacesState(): void {
    this._articleMarketplacesState.set(defaultArticleMarketplaces);
  }
}
